<template>
    <div class="fs5-link-generator" >
        <fs5-section-header :view="view.header" :showTooltip="view.header.showTooltip" />
        <div class="fs5-link-generator-button">
            <fs5-button
                v-for="(item, index) in view.buttons.row1"
                :key="index"
                :label="item.label"
                :btn-type="item.btnType"
                :text-transform-type="item.textTransformType"
                :icon="item.icon"
                @clicked="callToggleFunction(item.callback)"
            ></fs5-button>
        </div>

        <div class="fs5-link-generator-button">
            <fs5-button
                v-for="(item, index) in view.buttons.row2"
                :key="index"
                :label="item.label"
                :btn-type="item.btnType"
                :text-transform-type="item.textTransformType"
                :icon="item.icon"
                @clicked="callToggleFunction(item.callback)"
            ></fs5-button>
        </div>
        <!-- modal redirect link -->
        <modal-redirect-link-v5 :accessShortUrlFunc="accessShortUrl" :can_access_short_url="view.can_access_short_url" />

        <!-- modal magic funnel -->
        <modal-magic-funnel-v5
            :parentRefs="{
                btnMagicFunnelLinkGenerator: $refs.btnMagicFunnelLinkGenerator
            }"
        />

        <!-- modal whatsapp -->
        <modal-whatsapp-v5 />

        <!-- modal telegram -->
        <modal-telegram-v5 />

        <!-- modal URL shortner = NAO TEM. REDIRECT-->
    </div>
</template>

<script>
    export default {
        name: 'fs5-link-generator',
        props: ['view'],
        data: function () {
            return {
                openModalRedirectLink: false,
                openModalMagicFunnel: false,
                openModalWhatsapp: false,
                openModalTelegram: false,
                openModalAutoresponder: false,
                openModalConnectFunnels: false,
                openModalDisconnectFunnels: false,
                openModalDomainNS: false,

                pageLoaded: false,
                loading: true,
                calledOpen: false,

                // params
                openTool: null
            }
        },
        methods: {
            callToggleFunction(functionName){
                this[functionName]()
            },
            // toggle modal redirect link event listener
            toggleModalRedirectLinkEventListener() {
                this.openModalRedirectLink = !this.openModalRedirectLink
                if(this.openModalRedirectLink){
                    let vm = this
                    $('#createUrlRedirModal').modal({ show: vm.openModalRedirectLink })
                }
            },

            // toggle modal Magic Funnel event listener
            toggleModalMagicFunnelEventListener() {
                this.openModalMagicFunnel = !this.openModalMagicFunnel
                if(this.openModalMagicFunnel){
                    let vm = this
                    $('#linkMagicFunnel').modal({ show: vm.openModalMagicFunnel })
                }
            },
            // toggle modal Whatsapp event listener
            toggleModalWhatsappEventListener() {
                this.openModalWhatsapp = !this.openModalWhatsapp
                if(this.openModalWhatsapp){
                    let vm = this
                    $('#linkWhatsApp').modal({ show: vm.openModalWhatsapp })
                }
            },

            // toggle modal Telegram event listener
            toggleModalTelegramEventListener() {
                this.openModalTelegram= !this.openModalTelegram
                if(this.openModalTelegram){
                    let vm = this
                    $('#linkTelegram').modal({ show: vm.openModalTelegram })
                }
            },

            // toggle modal autoresponder event listener
            toggleModalAutoresponderEventListener() {
                this.openModalAutoresponder = !this.openModalAutoresponder
                if(this.openModalAutoresponder){
                    $('#autoresponder').modal('show')
                } else {
                    $('#autoresponder').modal('hide')
                }
            },

            // toggle Modal Connect Funnels  event listener
            toggleModalConnectFunnelsEventListener() {
                this.openModalConnectFunnels = !this.openModalConnectFunnels
                if(this.openModalConnectFunnels){
                    $('#modalConnectFunnels').modal('show')
                }
            },

            // toggle Modal disconnect Funnels  event listener
            toggleModalDisconnectFunnelsEventListener() {
                this.openModalDisconnectFunnels = !this.openModalDisconnectFunnels
                if(this.openModalDisconnectFunnels){
                    $('#modalDisconnectFunnels').modal('show')
                }
            },

            // toggle Modal domain DNS  event listener
            toggleModalModalDomainDNSEventListener() {
                this.openModalDomainNS = !this.openModalDomainNS
                if(this.openModalDomainNS){
                    $('#modalDomainNS').modal('show')
                }
            },

            accessShortUrl(){
                window.open(this.view.access_short_url, '_blank')
                // let vm = this
                // //Busca o token
                // let auth = btoa('builderall:EGb5jmeN');
                // $.ajax({
                //     url: `${vm.view.data.host_short_url}/api/v1/auth`,
                //     type: 'GET',
                //     async: false,
                //     contentType: 'application/json; charset=utf-8',
                //     headers: {
                //         "Authorization": "Basic " + auth
                //     },
                //     dataType: 'json',
                //     success: function(response) {
                //         if (response.status == 'success' && response.token != null) {
                //             $('#token').val(response.token);

                //             $('#form-list-short-url').submit();
                //         } else {
                //             alertMsg('error', 'Error generate short url token!');
                //         }
                //     },
                //     error: function(response) {
                //         console.log(response);
                //     }
                // });
            },
            openModalbySideMenu(){
                // OPEN MODAL
                this.openTool = new URL(location.href).searchParams.get('opentool');
                if(this.openTool !== undefined && this.openTool !== null) {
                    switch (this.openTool) {
                        case 'autoresponder':
                            this.toggleModalAutoresponderEventListener();
                            break;
                        case 'connect_domain':
                            this.toggleModalConnectFunnelsEventListener()
                            break;
                        case 'disconnect_domain':
                            this.toggleModalDisconnectFunnelsEventListener();
                            break;
                        case 'name_servers':
                            this.toggleModalModalDomainDNSEventListener()
                            break;
                        case 'createUrlRedirModal':
                            this.toggleModalRedirectLinkEventListener();
                            break;
                        case 'linkMagicFunnel':
                            this.toggleModalMagicFunnelEventListener();
                            break;
                        case 'linkWhatsApp':
                            this.toggleModalWhatsappEventListener();
                            break;
                        case 'linkTelegram':
                            this.toggleModalTelegramEventListener();
                            break;
                        case 'submit_short_url_list_1':
                            this.accessShortUrl();
                            break;
                    }
                    this.calledOpen = true
                }
            }
        },
        mounted() {
            let vm = this

            $( () => {
                vm.pageLoaded = true

                // hide modal Redirect Link event listener
                $('#createUrlRedirModal').on('hidden.bs.modal', vm.toggleModalRedirectLinkEventListener)

                // hide modal Magic Funnel event listener
                $('#linkMagicFunnel').on('hidden.bs.modal', vm.toggleModalMagicFunnelEventListener)

                // hide modal Whatsapp event listener
                $('#linkWhatsApp').on('hidden.bs.modal', vm.toggleModalWhatsappEventListener)

                // hide modal Telegram event listener
                $('#linkTelegram').on('hidden.bs.modal', vm.toggleModalTelegramEventListener)
            } )
        },
        watch: {
            pageLoaded: function(newVal, oldVal) {
                if( !this.calledOpen && newVal) {
                    this.openModalbySideMenu()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';

    .fs5-link-generator{
        font: inherit;
        .fs5-link-generator-button{
            font: inherit;
            border: 1x red solid;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
            grid-template-rows: auto;
            justify-content: stretch;
            align-items: center;

            column-gap: 1.8em;

            &:last-child{
                margin-top: 1.5em;
            }
        }
    }

    @media screen and (max-width: 700px){
        .fs5-link-generator{
            .fs5-link-generator-button{
                grid-template-columns: 1fr;
                row-gap: 1em;

                &:last-child{
                    margin-top: 1em;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/link_generator/index.vue